require("!!/var/lib/jenkins/workspace/TEST2/webapp/node_modules/script-loader/addScript.js")(require("!!/var/lib/jenkins/workspace/TEST2/webapp/node_modules/raw-loader/index.js!/var/lib/jenkins/workspace/TEST2/webapp/src/main/webapp/js/lib/kendo/kendo.virtuallist.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/main/webapp/js/lib/kendo/kendo.virtuallist.min.js
// module id = 187
// module chunks = 37